export type RailSpan = { top: number; height: number };

const FADE = 96;

export const railSpan = (
  flowTop: number,
  nodes: HTMLElement[]
): RailSpan | null => {
  if (!nodes.length) return null;
  const first = nodes[0].getBoundingClientRect();
  const last = nodes[nodes.length - 1].getBoundingClientRect();
  const top = first.top + first.height / 2 - flowTop;
  return { top, height: last.top + last.height / 2 - flowTop - top };
};

export const railMask = (
  span: RailSpan,
  textRects: { top: number; bottom: number }[]
): string => {
  const bands = textRects
    .map(({ top, bottom }) => [top - span.top, bottom - span.top])
    .filter(([a, b]) => b > 0 && a < span.height)
    .map(
      ([a, b]) =>
        `black ${Math.max(0, a - FADE)}px, transparent ${Math.max(0, a)}px ${Math.min(span.height, b)}px, black ${Math.min(span.height, b + FADE)}px`
    );
  return bands.length
    ? `linear-gradient(to bottom, black 0, ${bands.join(', ')} 100%)`
    : 'none';
};

/* The flow's tip IS the reading line's position on the rail - so at rest, a
   node at mid-screen has the fill exactly at it. The parallax feel comes
   from the temporal trailing applied by the driver, not from a rate change. */
export const tipPosition = (lineInFlow: number, span: RailSpan): number =>
  Math.min(span.height, Math.max(0, lineInFlow - span.top));
